module.exports = __webpack_public_path__ + "img/icon-neuro.81840daa.svg";